import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import bookingConfirmedImage from '../../../assets/images/booking-confirmed-light.svg';
import { t } from '../../../services/translation/translation';
import { formatRelativeDate } from '../../../utils/date';

type Props = {
  trip: TripOutput;
};

export const BookingConfirmed = ({ trip }: Props) => {
  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex">
        <strong>{t('share-route.trip-detail.booking-confirmed')}</strong>
        <span>{formatRelativeDate(trip.resume.departureAt, Date.now())}</span>
      </div>
      <img alt="confirmed" src={bookingConfirmedImage} />
    </div>
  );
};
